class FooterAccordion extends HTMLElement {
  constructor() {
    super();
    
    // Only proceed if this is actually in the footer
    if (!this.closest('.footer')) {
      return;
    }
    
    this.headerElements = this.querySelectorAll('.footer-block__heading');
    
    // Check if we're on mobile initially
    this.isMobile = window.innerWidth < 750;
    
    // Only apply accordion functionality on mobile
    if (this.isMobile) {
      this.setupMobileAccordion();
    }
    
    // Listen for window resize to adjust based on screen size
    window.addEventListener('resize', this.handleResize.bind(this));
  }
  
  setupMobileAccordion() {
    // Track if we've opened the first accordion
    let isFirstAccordion = true;
    
    this.headerElements.forEach(header => {
      // Only add event listeners and icons on mobile
      header.removeEventListener('click', this.toggleContent.bind(this, header));
      header.addEventListener('click', this.toggleContent.bind(this, header));
      
      // Find the associated content - look for the parent's next element with content class
      let content = header.nextElementSibling;
      
      // If no direct sibling, look within the footer block for content
      if (!content || !content.classList.contains('footer-block__details-content')) {
        const footerBlock = header.closest('.footer-block');
        if (footerBlock) {
          content = footerBlock.querySelector('.footer-block__details-content');
        }
      }
      
      if (!content) return;
      
      // If this is the first accordion item, expand it by default
      if (isFirstAccordion) {
        header.classList.add('footer-accordion--expanded');
        content.style.display = 'block';
        isFirstAccordion = false;
        
        // Only add toggle icon if it doesn't already exist
        if (!header.querySelector('.footer-accordion__icon')) {
          const toggleIcon = document.createElement('span');
          toggleIcon.classList.add('footer-accordion__icon');
          toggleIcon.innerHTML = '−'; // Minus sign for expanded state
          header.appendChild(toggleIcon);
        }
      } else {
        // Add collapsed state class to others
        header.classList.add('footer-accordion--collapsed');
        
        // Only add toggle icon if it doesn't already exist
        if (!header.querySelector('.footer-accordion__icon')) {
          const toggleIcon = document.createElement('span');
          toggleIcon.classList.add('footer-accordion__icon');
          toggleIcon.innerHTML = '+';
          header.appendChild(toggleIcon);
        }
        
        // Hide other accordion content initially on mobile
        content.style.display = 'none';
      }
    });
  }
  
  removeMobileAccordion() {
    this.headerElements.forEach(header => {
      // Remove mobile-specific classes and elements when switching to desktop
      header.classList.remove('footer-accordion--collapsed');
      header.classList.remove('footer-accordion--expanded');
      
      // Remove the toggle icon when in desktop mode
      const icon = header.querySelector('.footer-accordion__icon');
      if (icon) {
        icon.remove();
      }
      
      // Always show content on desktop
      const content = header.nextElementSibling;
      if (content) {
        content.style.display = '';
      }
    });
  }
  
  toggleContent(header, event) {
    // Only trigger on mobile
    if (window.innerWidth >= 750) return;
    
    event.preventDefault();
    
    // Find the associated content using the same logic as setupMobileAccordion
    let content = header.nextElementSibling;
    if (!content || !content.classList.contains('footer-block__details-content')) {
      const footerBlock = header.closest('.footer-block');
      if (footerBlock) {
        content = footerBlock.querySelector('.footer-block__details-content');
      }
    }
    
    const isExpanded = header.classList.contains('footer-accordion--expanded');
    
    // Toggle content visibility
    if (content) {
      if (isExpanded) {
        header.classList.remove('footer-accordion--expanded');
        header.classList.add('footer-accordion--collapsed');
        content.style.display = 'none';
        const icon = header.querySelector('.footer-accordion__icon');
        if (icon) icon.innerHTML = '+';
      } else {
        header.classList.add('footer-accordion--expanded');
        header.classList.remove('footer-accordion--collapsed');
        content.style.display = 'block';
        const icon = header.querySelector('.footer-accordion__icon');
        if (icon) icon.innerHTML = '−';
      }
    }
  }
  
  handleResize() {
    const newIsMobile = window.innerWidth < 750;
    
    // Only make changes if the state has changed
    if (newIsMobile !== this.isMobile) {
      this.isMobile = newIsMobile;
      
      if (this.isMobile) {
        // Switch to mobile mode
        this.setupMobileAccordion();
      } else {
        // Switch to desktop mode
        this.removeMobileAccordion();
      }
    }
  }
}

customElements.define('footer-accordion', FooterAccordion);